import { render, staticRenderFns } from "./ActivityTimeLineItemManagePropertiesOnSource.vue?vue&type=template&id=15f9c50f&"
import script from "./ActivityTimeLineItemManagePropertiesOnSource.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemManagePropertiesOnSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports